/**
 * MeshInstance2D registration: the parser, which reuses the Node2D parse.
 * linterParser.ts holds the property validators.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode2D } from '../../base/node2d/parser';
const meshInstance2DRegistration = {
    typeName: 'MeshInstance2D',
    parser: parseNode2D,
};
nodeRegistry.register(meshInstance2DRegistration);
//# sourceMappingURL=index.js.map